var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-12",class:{ 'full-width': _vm.fullWidthComponent }},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c(_vm.view,{tag:"component",attrs:{"params":_vm.params}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }